import { render, staticRenderFns } from "./FacebookBinding.vue?vue&type=template&id=551a8c23&scoped=true"
import script from "./FacebookBinding.vue?vue&type=script&lang=js"
export * from "./FacebookBinding.vue?vue&type=script&lang=js"
import style0 from "./FacebookBinding.vue?vue&type=style&index=0&id=551a8c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a8c23",
  null
  
)

export default component.exports